module.exports = [
  '$resource',
  function SubscriptionResource(
    $resource,
  ) {
    const resourceObject = $resource('/api/v2/patients/subscriptions/:id',
      {
        patientId: '@patient.id',
      },
      {
        patch: {
          method: 'PATCH',
        },
      },
    );

    angular.extend(resourceObject.prototype, {
      $saveNotificationPreference(callback) {
        return resourceObject.patch(
          {
            id: this.id,
          },
          { operations: [{
            op: 'replace',
            path: '/notification_preference',
            value: this.notificationPreference,
          }] },
          callback,
        );
      },
    });

    return resourceObject;
  },
];



// WEBPACK FOOTER //
// ./main/factories/subscription-resource.js